import React, { Component } from 'react'
import { Form, Select } from 'antd'
import { AgeProvider, AgeConsumer } from '../../../../context/AgeContext'

export default class MappingAgeForm extends Component {
  render() {
    return (
      <AgeProvider>
        <AgeConsumer>
          {({ fetching, ages, requestAgeList }) => {
            if (!fetching && !ages) {
              setTimeout(() => {
                requestAgeList({
                  options: {
                    limit: 9999
                  }
                })
              }, 50)
            }

            const agesOptions = ages?.map(age => {
              return {
                label: age.name,
                value: age.key
              }
            }) as any

            return (
              <Form.Item
                label="Age"
                name="age_key"
                rules={[
                  {
                    required: true,
                    message: 'Missing an age'
                  }
                ]}
              >
                <Select
                  loading={fetching}
                  placeholder="Select an age"
                  options={agesOptions}
                />
              </Form.Item>
            )
          }}
        </AgeConsumer>
      </AgeProvider>
    )
  }
}
